"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _tint = _interopRequireDefault(require("polished/lib/color/tint"));

var _transitions = _interopRequireDefault(require("polished/lib/shorthands/transitions"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anakiwa';
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0];

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors,
      contrasts = _useTheme.contrasts;

  return {
    root: _objectSpread({
      boxSizing: 'content-box',
      border: 'none',
      minHeight: spacing(size),
      backgroundColor: colors.transparent,
      color: contrasts[color],
      borderRadius: spacing(size),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: spacing.apply(void 0, (0, _toConsumableArray2["default"])(padding)),
      WebkitTapHighlightColor: 'transparent',
      ':disabled': {
        cursor: 'auto'
      },
      ':focus:not(:disabled), :hover:not(:disabled)': {
        outline: 'none',
        backgroundColor: (0, _tint["default"])(0.25, colors[color]),
        ':active': {
          backgroundColor: colors[color]
        }
      }
    }, (0, _transitions["default"])(['background-color', 'filter', 'opacity', 'border-color', 'color', 'box-shadow'], '0.2s ease-in-out'))
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors, contrasts }}", function () {
  return [_useTheme2["default"]];
});

function TouchableOpacity(props, ref) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'button' : _props$as,
      size = props.size,
      color = props.color,
      padding = props.padding,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "size", "color", "padding"]);
  var classes = useStyles(color, size, padding);
  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    ref: ref,
    css: classes.root
  }, other));
}

__signature__(TouchableOpacity, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(TouchableOpacity);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/TouchableOpacity/index.tsx");
  reactHotLoader.register(TouchableOpacity, "TouchableOpacity", "/builds/bA1zbJom/0/gojob/ui-bits/src/TouchableOpacity/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/TouchableOpacity/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();